import { colors, styles } from './styles';

export const createCollectionModalStyles = {
    backdrop: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
    },
    container: {
        backgroundColor: colors.surfaceElevated,
        borderRadius: '16px',
        padding: '20px',
        width: '90%',
        maxWidth: '360px',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '8px'
    },
    input: {
        ...styles.input,
        backgroundColor: colors.background,
        border: 'none',
    },
    button: (isSubmitting) => ({
        ...styles.button,
        cursor: isSubmitting ? 'not-allowed' : 'pointer',
        opacity: isSubmitting ? 0.5 : 1,
    }),
    cancelButton: (isSubmitting) => ({
        ...styles.button,
        ...styles.secondaryButton,
        cursor: isSubmitting ? 'not-allowed' : 'pointer',
        opacity: isSubmitting ? 0.5 : 1,
    }),
    submitButton: (isDisabled) => ({
        ...styles.button,
        ...styles.whiteButton,
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.5 : 1,
    }),
}; 